// React contexts would have been used instead of this,
// except that the React version used by this package is
// not that same code that gf-web users. Contexts don't work
// in this situation.

const AppStore: any = {};
export default AppStore;
